const DATE_FORMAT = 'YYYYMMDD';
const DATE_FORMAT_DASH = 'YYYY-MM-DD';
const FULL_MONTH_DAY_FORMAT = 'MMMM D';
const FULL_MONTH_DAY_YEAR_FORMAT = 'MMMM D, YYYY';
const DAY_FULL_MONTH_YYYY_FORMAT = 'D MMMM YYYY, HH:mm';
const DATETIME_FORMAT = 'YYYYMMDD HH:mm:SS';
const DATETIME_FORMAT_WITHOUT_SEC = 'DD/MM/YYYY HH:mm';


export default {
    DATE_FORMAT: DATE_FORMAT,
    DATETIME_FORMAT: DATETIME_FORMAT,
    FULL_MONTH_DAY_FORMAT: FULL_MONTH_DAY_FORMAT,
    DATETIME_FORMAT_WITHOUT_SEC: DATETIME_FORMAT_WITHOUT_SEC,
    FULL_MONTH_DAY_YEAR_FORMAT: FULL_MONTH_DAY_YEAR_FORMAT,
    DAY_FULL_MONTH_YYYY_FORMAT: DAY_FULL_MONTH_YYYY_FORMAT,
    DATE_FORMAT_DASH: DATE_FORMAT_DASH
}

export {
    DATE_FORMAT, DATETIME_FORMAT, FULL_MONTH_DAY_FORMAT, DATETIME_FORMAT_WITHOUT_SEC,FULL_MONTH_DAY_YEAR_FORMAT,DAY_FULL_MONTH_YYYY_FORMAT, DATE_FORMAT_DASH
}